import React, { forwardRef, Ref } from 'react';
import { GameTileBase, TSharedGameTileProps } from './GameTileUtils';
import { FeatureGamePage } from '../constants/translationConstants';
import '../../../../css/common/_gameTiles.scss';

export const SponsoredGameTile = forwardRef(
  (
    { translate, id, buildEventProperties, gameData }: TSharedGameTileProps,
    ref: Ref<HTMLDivElement>
  ): JSX.Element => {
    return (
      <div
        ref={ref}
        className='grid-item-container game-card-container'
        data-testid='game-tile-sponsored'>
        <GameTileBase id={id} buildEventProperties={buildEventProperties} gameData={gameData}>
          <div className='game-card-native-ad'>
            <div className='native-ad-label'>{translate(FeatureGamePage.LabelSponsoredAd)}</div>
          </div>
        </GameTileBase>
      </div>
    );
  }
);
SponsoredGameTile.displayName = 'SponsoredGameTile';
export default SponsoredGameTile;
